<template>
  <div class="mt55">
    <div
      class="w1200"
      v-show="isShow"
    >
      <div class="head clearfix">
        <HT
          text="wconcept"
          style="margin-top:0px;margin-left:-35px;float:left"
        />
        <div class="fr bread clearfix">
          <div
            class="fl"
            style="margin-right:15px;color: #064186"
          >
            当前位置:
          </div>
          <div class="fl">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">
                首页
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/warehouse/wconcept' }">
                医药共享仓
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/warehouse/wconcept' }">
                项目概念
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>
      <div class="content clearfix pr">
        <div class="demo-image__lazy">
          <el-image
            v-for="url in urls"
            :key="url"
            :src="url"
            lazy
          />
        </div>
        <!-- <div class="left pic fl"></div>
                <div class="right text fr">
    
                </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import HT from '@/components/h2.vue'

export default {
    data() {
        return {
            list: [],
            isShow: true,
            urls: [
                'http://www.goodyiyao.com/img/yiyaocang2.5b30c755.jpg',
                'http://www.goodyiyao.com/img/wconcept_2.668fa274.jpg',
            ]
        }
    },
    components: {
        HT
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .content{
        width: 1200px;
        margin:20 auto;
        /* background-image: url('../../../assets/images/yiyaocang2_xiao.jpg'); */
        background-size: cover;
        background-position: center;
        /* 清楚图片文字选中、蓝色覆盖效果 */
        pointer-events:none;
        -webkit-user-select:none;
        -moz-user-select:none;
        -o-user-select:none;
        user-select:none;
    }
    /* .content .left.pic{
        width: 395px;
        height: 233px;
        background: url('../../../assets/images/gygd.jpg') center center no-repeat;
    } */
    .content .right.text{
        width: 650px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 55px;
        text-indent: 2em;
        font-size: 16px;
        line-height: 26px;
        color: #666;
    }
</style>

<style>
    .head{
        position: relative;
    }
    .bread{
        position: absolute;
        right: 0;
        bottom: 15px;
    }
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
</style>